import { NgModule } from '@angular/core';
import { SharedSolaceMainService } from 'src/solace/sharedSolace.main.service';
import { SharedSolaceMiddlewareService } from 'src/solace/sharedSolace.middleware.service';
import { SharedSolaceStreamService } from 'src/solace/sharedSolace.stream.service';

@NgModule({
  providers: [
    SharedSolaceMainService,
    SharedSolaceMiddlewareService,
    SharedSolaceStreamService,
  ],
})
export class SharedSolaceModule {}
